// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import { mapShippingCustomCarrier } from "@bg/App/Store/Selectors/Checkout/CheckoutSelectors";
import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchResetPaymentProfiles,
    PopulateApiParameter,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";

export const xMapShippingCustomCarrier: typeof SetCartStatus = props => {
    const cart = props.cartToUpdate;
    const state = props.getState() as CustomAppState;
    const carrierInformation = mapShippingCustomCarrier(state);

    cart.properties = {
        ...cart.properties,
        ...carrierInformation,
        updateAssociatedSalesRep: state.xCheckout.updateAssociatedSalesRep,
        associatedSalesRep: state.xCheckout.associatedSalesRep,
    } as any;

    cart.poNumber = state.xCheckout.po;
    cart.notes = state.xCheckout.notes;
    props.cartToUpdate = cart;
};

const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const requestedDeliveryDate = props.getState().pages.onePageCheckout.requestedDeliveryDate;
    props.apiParameter.cart.requestedDeliveryDate = requestedDeliveryDate
        ? formatDateWithTimezone(requestedDeliveryDate)
        : "";
};

export const xClearCustomStore: typeof DispatchResetPaymentProfiles = props => {
    props.dispatch({
        type: "xCheckout/clearCustomStore",
    } as any);

    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/CompleteApplyPromotion",
        successMessage: "",
        errorMessage: "",
        isPromotionAppliedSuccess: false,
    });
};

addToChainAfter(chain, SetCartStatus, xMapShippingCustomCarrier);
addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToEndOfChain(chain, xClearCustomStore);
